import './style.scss'
import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'

import AvatarImg from 'components/images/AvatarImg'
import { getAutomationIcon, getAutomationNameTag } from 'utils/AutomationActivity'
import { getFormatedDate } from 'utils'

/**
 * Display activity message
 * @param {string} id
 * @param {string} avatar
 * @param {string} name
 * @param {object} activityData
 */
function ActivityMsg({ id, avatar, name, activityData }) {
  const [activityAvatar, setActivityAvatar] = useState(avatar)
  const [activityName, setActivityName] = useState(name)
  const [activityText, setActivityText] = useState('')
  const [activityLabel, setActivityLabel] = useState('')
  const [isAllOperatorsVisibles, setIsAllOperatorsVisibles] = useState(false)
  const [activityUrlVisited, setActivityUrlVisited] = useState('')

  useEffect(() => {
    if (!avatar && activityData.insertBy) {
      const url = getAutomationIcon(activityData.insertBy)

      if (url) setActivityAvatar(url)
    }

    if (!name && activityData.insertBy) {
      const title = getAutomationNameTag(activityData.insertBy)
      setActivityName(title ? I18n.t(title) : '')
    }

    switch (activityData.type) {
      case 'category': {
        const categoryType = activityData?.metadata?.categoryType
        setActivityText('conversations_activity_category_add')
        setActivityLabel(
          categoryType
            ? I18n.t(`dashboard_${categoryType}`)
            : activityData.text
        )
        break
      }
      case 'category_removed': {
        const categoryType = activityData?.metadata?.categoryType
        setActivityText('conversations_activity_category_remove')
        setActivityLabel(
          categoryType
            ? I18n.t(`dashboard_${categoryType}`)
            : activityData.text
        )
        break
      }
      case 'list_add':
        setActivityText('conversations_activity_list_add')
        setActivityLabel(activityData.text)
        break
      case 'list_removed':
        setActivityText('conversations_activity_list_remove')
        setActivityLabel(activityData.text)
        break
      case 'assigned_add':
        setActivityText('conversations_activity_assigned_add')
        break
      case 'assigned_removed':
        setActivityText('conversations_activity_assigned_remove')
        break
      case 'status_changed':
        setActivityText('conversations_activity_status_change')
        setActivityLabel(I18n.t(`states_${activityData.state}`))
        break
      case 'center_changed':
        if (activityData.brandName && !activityData.delegationName) {
          setActivityText('conversations_activity_center_brand_change')
          setActivityLabel(activityData.brandName)
        } else if (!activityData.brandName && activityData.delegationName) {
          setActivityText('conversations_activity_center_delegation_change')
          setActivityLabel(activityData.delegationName)
        } else if (activityData.brandName && activityData.delegationName) {
          setActivityText('conversations_activity_center_change')
          setActivityLabel(`${activityData.brandName}/${activityData.delegationName}`)
        }
        break
      case 'act_payment_create':
        setActivityText('act_payment_create')
        setActivityLabel(`${activityData.metadata.payPrice} ${activityData.metadata.payPriceCurrency.toLowerCase()}`)
        break
      case 'act_payment_renew':
        setActivityText('act_payment_renew')
        setActivityLabel(`${activityData.metadata.payPrice} ${activityData.metadata.payPriceCurrency.toLowerCase()}`)
        break
      case 'act_payment_cancel':
        setActivityText('act_payment_cancel')
        setActivityLabel(`${activityData.metadata.payPrice} ${activityData.metadata.payPriceCurrency.toLowerCase()}`)
        break
      case 'act_payment_refund':
        setActivityText(activityData.metadata.payIsPartial ? 'act_payment_refund_partial' : 'act_payment_refund_total')
        setActivityLabel(`${activityData.metadata.payPrice} ${activityData.metadata.payPriceCurrency.toLowerCase()}`)
        break
      case 'act_customer_url_visited':
        setActivityText(I18n.t('act_customer_url_visited_text'))
        setActivityUrlVisited(activityData.urlVisited || '')
        break
      case 'act_read':
        setActivityText('conversations_activity_act_read')
        break
      case 'act_unread':
        setActivityText('conversations_activity_act_unread')
        break
      case 'act_mnemonic_removed':
        setActivityText('conversations_activity_act_mnemonic_removed')
        break
      case 'act_exported':
        setActivityText('conversations_activity_act_exported')
        break
      default:
        setActivityText('')
        setActivityLabel('')
        break
    }
  }, [avatar, name, activityData])

  const renderAssignedTo = ({ operators }) => operators.map((operator, index) => (
    <div
      key={index}
      className='activity-msg__label'
      style={{
        display: index && !isAllOperatorsVisibles ? 'none' : null
      }}
    >
      <figure className='activity-msg__avatar'>
        <AvatarImg
          src={operator.operatorPicture}
        />
      </figure>
      <span className='text-ellipsis'>{operator.operatorName || operator.operatorEmail}</span>
    </div>
  ))

  return (
    <div id={id} className='activity-msg'>
      <div className='activity-msg__separator' />
      <div className='activity-msg__bubble'>
        <figure className='activity-msg__avatar'>
          <AvatarImg
            src={activityAvatar}
          />
        </figure>
        <p className='activity-msg__text'>
          <span>{activityName} </span>{I18n.t(activityText)}
        </p>
        {activityUrlVisited !== '' && (
          <div className=''>
            <span
              className={'text-ellipsis-wrap'}
              style={{
                white:'60%',
                borderRadius: '10px',
                padding: '3.5px 7.5px',
                color:  '#ef8624',
                backgroundColor: 'transparent'
              }}
            >
              <a href={activityUrlVisited} rel="noopener noreferrer" target={"_blank"} title={activityUrlVisited}>
                {activityUrlVisited.length > 24 ? `${activityUrlVisited.substring(0,24)}...`: activityUrlVisited}
              </a>
            </span>
          </div>
        )}
        {activityLabel && (
          <div className='activity-msg__label'>
            <span
              className={activityData.type.includes('category') ? 'text-ellipsis' : 'text-ellipsis-wrap'}
              style={{
                borderRadius: activityData.type.includes('category') ? '10px' : null,
                padding: activityData.type.includes('category') ? '3.5px 7.5px' : null,
                color: activityData.type.includes('category')
                  ? activityData.metadata.categoryColor ? '#FFFFFF' : '#333333'
                  : '#333333',
                backgroundColor: activityData.type.includes('category')
                  ? activityData.metadata.categoryColor || 'rgb(249, 246, 246)'
                  : 'transparent'
              }}
            >
              {activityLabel}
            </span>
          </div>
        )}
        {activityData.type.includes('assigned') && (
          <>
            {renderAssignedTo({ operators: activityData.assignedTo || [] })}
            {activityData.assignedTo?.length > 1 && (
              <button
                className='activity-msg__more-btn'
                onClick={() => setIsAllOperatorsVisibles(!isAllOperatorsVisibles)}
              >
                {!isAllOperatorsVisibles
                  ? I18n.t('dashboard_more-operators', { count: activityData.assignedTo.length - 1 })
                  : I18n.t('dashboard_view-less')
                }
              </button>
            )}
          </>
        )}
      </div>
      <div className='activity-msg__separator' />
      <div className='activity-msg__bubble'>
        <p>{getFormatedDate({ isoString: activityData.date, withTime: true, withYear: true })}</p>
      </div>
    </div>
  )
}

export default ActivityMsg
